import React from 'react';
import CrossRoad from "../UI/Crossroad";

const CrossRoad_5KBlue_5GRed_5FBlack = () => <CrossRoad coords="1663.000000, 554.000000"/>;

export default CrossRoad_5KBlue_5GRed_5FBlack;
